import { DRIVER_SCOPE, SQUAD_SCOPE } from "model/Roster/RosterScope";
import {
  TournamentDriverRoster,
  TournamentSquadRoster,
} from "model/Roster/TournamentRoster";

export type TournamentDrivers = {
  rosters: TournamentDriverRoster[];
  scope: typeof DRIVER_SCOPE;
};

export type TournamentSquads = {
  rosters: TournamentSquadRoster[];
  scope: typeof SQUAD_SCOPE;
};

export type TournamentTeams = TournamentDrivers | TournamentSquads;

export const getTournamentRosterIds = (teams: TournamentTeams) => {
  return teams.rosters.map((r) => r.id);
};

export const getTournamentDriverIds = (teams: TournamentTeams) => {
  if (teams.scope === DRIVER_SCOPE) {
    return teams.rosters.map((r) => r.id);
  }

  return teams.rosters.flatMap((r) => r.drivers.map((d) => d.id));
};

export const getTournamentRosterIdFromDriverId = (
  teams: TournamentTeams,
  driverId: string
) => {
  if (teams.scope === DRIVER_SCOPE) {
    return teams.rosters.find((r) => r.id === driverId) ? driverId : undefined;
  }

  return teams.rosters.find((r) => r.drivers.find((d) => d.id === driverId))
    ?.id;
};

export const getTournamentDriverName = (
  teams: TournamentTeams,
  driverId: string
) => {
  if (teams.scope === DRIVER_SCOPE) {
    return teams.rosters.find((r) => r.id === driverId)?.name;
  }

  for (let i = 0; i < teams.rosters.length; i++) {
    const roster = teams.rosters[i];
    const driver = roster.drivers.find((d) => d.id === driverId);
    if (!!driver) {
      return driver.name;
    }
  }

  return undefined;
};

export const getTournamentDisplayTrigram = (
  teams: TournamentTeams,
  rosterId: string
) => {
  return teams.scope === DRIVER_SCOPE
    ? teams.rosters.find((r) => r.id === rosterId)?.name
    : teams.rosters.find((r) => r.id === rosterId)?.trigram;
};

export const getTournamentDriverDetails = (
  teams: TournamentTeams,
  rosterId: string
) => {
  if (teams.scope === DRIVER_SCOPE) {
    const roster = teams.rosters.find((r) => r.id === rosterId);
    return !!roster ? [{ id: roster.id, name: roster.name }] : undefined;
  }

  const roster = teams.rosters.find((r) => r.id === rosterId);
  return !!roster ? roster.drivers : undefined;
};
